import { render, staticRenderFns } from "./EmailTemplateFields.vue?vue&type=template&id=4994f30d&scoped=true"
import script from "./EmailTemplateFields.vue?vue&type=script&lang=js"
export * from "./EmailTemplateFields.vue?vue&type=script&lang=js"
import style0 from "./EmailTemplateFields.vue?vue&type=style&index=0&id=4994f30d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4994f30d",
  null
  
)

export default component.exports